import sha256 from "./sha256.js";
import replaceAll from 'string.prototype.replaceall';
import Util from "./util.js";

replaceAll.shim(); // will be a no-op if not needed

const FSM = {
  init: () => {
    let obj = { _states: { 'false': "NONE" } };

    obj.add = (name, active) => {
      let currentlyActive = (Util.isFunction(active)) ? active() : active;
      if (obj.hasActive() && currentlyActive) {
        throw `Invalid state ${name}! State ${obj.current()} is already active`;
      }
      obj._states[(!!currentlyActive).toString()] = name;
      return obj;
    };

    obj.current = () => obj._states['true'];
    obj.hasActive = () => !!obj.current();

    // create aliases
    obj.done = obj.current;
    obj.get = obj.current;
    obj.determine = obj.current;

    return obj;
  }
};

export default FSM;